import React, { useState, useEffect } from 'react';
import axios from 'axios';
import axiosIntance,{fetchInstance} from '../../helper/axios'
import { useHistory } from "react-router-dom";
import ReactDOM from 'react-dom';
import './products.css';
import MaterialTable from "material-table";
import Sidebar from '../Template/Sidebar/Sidebar';
import Header from '../Template/Header/Header';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import {baseUrl} from '../../config';
import {clickColor,inArray} from './../../library/util';
import Loader from "react-loader-spinner";
function Products() {
    console.log('Cssnotes')
    const [selectedRow, setSelectedRow] = useState(null);
    const history = useHistory();
    const [loader,setLoader]=useState(false)
    const [selectedrowList,setSelectedRowList]=useState([]);


  const setRowBackground = (selectedRow)=>{
          if(inArray(selectedRow.tableData.id,selectedrowList)==false){ 
          setSelectedRowList(oldArray => [...oldArray,selectedRow.tableData.id] );
          setSelectedRow(selectedRow.tableData.id)
          console.log(selectedrowList)
          }else{    
            setSelectedRow(500000)
            setSelectedRowList([])
          }
        }
      
checkUserTypeFn(history);

function checkUserTypeFn(history){
  const userdata=JSON.parse(localStorage.getItem('userdata'));
  const usertype=userdata.type;
  console.log('in check usertype fn');
  console.log(usertype)
  if(usertype!='admin' && usertype!='superadmin' && usertype!='subadmin' && usertype!='databasehelper' && usertype!='owneradmin'){
    history.push('/');
 }

}
  
    const handleSignOut = () => {
        console.log('logout')
        window.localStorage.setItem('isLogin',false);
        history.push('/');
      }
    
      if(localStorage.getItem('isLogin')==="false" || localStorage.getItem('isLogin')==null){
        history.push('/');
      }
    const [cssCodesData,setcssCodesData]=useState([])
    const [resultCount,setResultCount]=useState(0);
    const [resultCountCounter,setResultCountCounter]=useState(0);
  
    const [message, setMessage] = useState('')
    const [successMsg,setSuccessMsg]=useState('')
    const data = [['attribute', 'attribute2'], ['value1', 'value2']];

    useEffect(() => {
      setLoader(true)
      axiosIntance.get(baseUrl+'/count/products', {}).then(response => {
        console.log('resultCount='+response.data.result);
        setResultCount(response.data.result);
        setResultCountCounter(1);
        setLoader(false)
      }).catch(error => {
        console.log(error)
        setMessage('Something went wrong');
      });
  
  
      return () => {
        console.log('un subscribe')
      }
  
  
  
    }, [])

      const SubmitDelete = (e) => {

        confirmAlert({
          title: '',
          message: 'Are you sure want to delete All data',
          buttons: [
            {
              label: 'Yes',
              onClick: () => 
              axiosIntance.delete(baseUrl+'/products', {}).then(response => {
                setSuccessMsg('Deleted!')
               // setTimeout(()=>window.location.href = '/viewproducts',2000)
              }).catch(error => {
                setMessage('Something went wrong');
              })
    
            },
            {
              label: 'No',
              onClick: () => console.log('No')
            }
          ]
        });
      }
    return (
        <div id="wrapper" className>
      <Sidebar />
      <Header handleSignOut={handleSignOut} />


    <div className='delete-div'>
      {
         resultCount>0 ? <button type="button"  onClick={SubmitDelete} className="btn btn-primary">Delete All </button>:''
       
      }
     
    </div>
    <div className='errorMsg'>{message}</div>
    <div className='successMsg viewScreen'>{successMsg}</div>


      <section id="content-wrapper">

      {loader &&
    <div className='loaderDiv'>  
        <Loader
              type="Circles"
              color="#b4d6fa"
              height={100}
              width={100}
              //timeout={1000} //3 secs
          />
    </div> 
    }
      {resultCountCounter>0 && 
        <MaterialTable
        // onRowClick={((evt, selectedRow) => setSelectedRow(selectedRow.tableData.id))}
        onRowClick={((evt, selectedRow) => 
          setRowBackground(selectedRow)
          )}


          columns={[
            { title: "SKU", field: "sku" },
            { title: "Product.Name", field: "product_name" },
            { title: "Product.Category", field: "product_category" },
            { title: "Is.Reship", field: "is_reship" },
            // { title: "code", field: "code" },
            { title: "Product.Type", field: "product_type" },
            { title: "Number.of.Units", field: "number_of_units" },
            { title: "Entity", field: "entity" },
            { title: "Brand", field: "brand" },
            { title: "Offer", field: "offer" },
            { title: "Product.ID", field: "product_id" },
            { title: "Per.Order.COGS", field: "per_order_cogs" },
            { title: "Front.End", field: "front_end" },
            { title: "Upsell", field: "upsell" },
            { title: "Warranty", field: "warranty" },
            { title: "Click.Bump", field: "click_bump" },
            { title: "Dummy.Product", field: "dummy_product" },
            { title: "Continuity.Offer", field: "continuity_offer" },
            { title: "Shippable", field: "shippable" },

            
            
            { title: "Bundle", field: "bundle" },
            { title: "Bundled.Product.IDs", field: "bundled_product_ids" },

            { title: "prime.SKU", field: "prime_sku" },
            { title: "parent.SKU", field: "parent_sku" },
            { title: "ship.cost.per.FE", field: "ship_cost_per_fe" },
            { title: "handling.cost.per.FE", field: "handling_cost_per_fe" },
            { title: "CS.cost.per.FE", field: "cs_cost_per_fe" },
            { title: "effective.date", field: "effective_date" },
            
           
          ]}
          data={query =>
            new Promise((resolve, reject) => {
              // console.log(query)
           
              let url = baseUrl+'/products?'
              url += `&_page=${query.page + 1}`
              url += `&_limit=${query.pageSize}`
              fetchInstance(url)
                .then(response => response.json())
                .then(result => {
                  
                 
                  resolve({
                    data: result.result,
                    page: query.page,
                    totalCount: resultCount,
                  })
                })
            })
          }
        
          options={{
            sorting: false,
            search: false,
            loadingType: 'overlay',
            maxBodyHeight: '500px',
            headerStyle: { position: 'sticky', top: 0,fontSize:'17px',fontWeight:'bold' },
            rowStyle: rowData => ({
              backgroundColor: (selectedRow === rowData.tableData.id) ? clickColor : ''
            })
            // headerStyle: { fontSize:'15px',fontWeight:'bold' }
          }}
          title="Products"
        />
      }
      </section>
    </div>
    )
}

export default Products
